<script>
  import BlogPostMeta from '$lib/BlogPostMeta.svelte'
  import RichText from '$lib/RichText.svelte'
  import Image from '$lib/Image.svelte'
  import Html from '$lib/Html.svelte'

  export let expanded = false
  export let items = []
</script>

<div class="items" class:expanded>
  {#each items as item}
    <div class="item">
      {#if item.image && !expanded}
        <div class="image">
          <Image
            src={item.image?.url}
            alt={item.image?.alt || 'Blog post banner image'}
            sizes="90vw"
            variants={[700, 1000, 1300, 1400]}
            aspect={0.4}
            width="1000"
            height="400" />
        </div>
      {/if}

      <div class="body">
        <div class="intro">
          <Html size={expanded ? null : 'small'}>
            {#if expanded}
              <a href={item.link}>
                <h2 class="h2">{item.title}</h2>
              </a>
            {:else}
              <h2 class="h3">{item.title}</h2>
            {/if}
            <p>{item.description}</p>
          </Html>
        </div>
        {#if expanded}
          <Html size="small">
            <RichText level={2} content={item.body} />
          </Html>
        {/if}
      </div>
      <div class="meta">
        <BlogPostMeta
          date={item.date}
          author={expanded ? null : item.author.name}
          portrait={expanded ? null : item.author.image} />
        {#if !expanded}
          <a class="link" href={item.link}>
            <span class="u-hidden">Read article</span>
          </a>
        {/if}
      </div>
    </div>
  {/each}
</div>

<style>
  .items {
    display: grid;
    gap: 4rem;
  }

  .items:not(.expanded) {
    text-wrap: balance;
  }

  .expanded .item {
    display: flex;
    flex-direction: column;
  }

  .expanded {
    margin-top: 2rem;
  }

  .expanded .meta {
    order: -1;
    margin: 0 0 0.75rem;
  }

  .expanded .intro {
    margin-bottom: 2rem;
  }

  @media (width > 1000px) {
    .items {
      grid-template-columns: 1fr 1fr;
      gap: 6rem 4rem;
    }

    .expanded {
      grid-template-columns: 1fr;
      gap: 5rem;
    }

    .expanded .item {
      flex-direction: row;
      align-items: flex-start;
    }

    .expanded .meta {
      position: sticky;
      top: 2rem;
      flex: 0 0 14rem;
    }
  }

  .item {
    position: relative;
  }

  .image {
    border-radius: var(--border-radius-md);
    background: rgb(var(--rgb-light-gray));
    overflow: hidden;
  }

  .body {
    margin: 1.5rem 0 1rem;
  }

  .expanded .body {
    margin: 0;
  }

  .expanded .item + .item {
    border-top: 1px solid rgba(var(--rgb-gray), 0.25);
    padding: 5rem 0 0;
  }

  .link::before {
    content: '';
    position: absolute;
    inset: 0;
  }
</style>
